export default "__VITE_ASSET__7PVKTvdH__"